import React from 'react';

import _ from 'lodash';

import FieldGroup from '../../Fields/FieldGroup';
import Field from '../../Fields/Field';
import InputTextField from '../../Fields/InputTextField';
import InputSelectField from '../../Fields/InputSelectField';
import InputRadioGroupField from '../../Fields/InputRadioGroupField';
import PromoCodeTable from '../../Fields/PromoCodeTable';

import PromoCode from '../../../Entities/PromoCode';


class RateDetailGeneralPanel extends React.Component {
  state = {
    displayInactivePromoCodes: false
  };


  handleAddPromoCodeClick = () => {
    this._onPromoCodeChange(null, new PromoCode());
  }


  handleToggleInactivePromoCodesClick = () => {
    this.setState({
      displayInactivePromoCodes: (this.state.displayInactivePromoCodes) ? false : true
    });
  }


  _onPromoCodeChange = (ident, value) => {
    const data = _.cloneDeep(this.props.rate.fields.promo_codes.value);

    // Handle adding new promo code
    if (ident === null) ident = data.length;

    if (value === null) {
      data.splice(ident, 1);
    }
    else {
      data[ident] = value;
    }

    this._onInputChange('promo_codes')(data);
  }


  _onInputChange(inputId) {
    return value => {
      switch (inputId) {
        case 'active':
          value = (value === 'true') ? true : false;
          break;
        default:
      }

      this.props.onValueChange(inputId, value);
    };
  }


  render () {
    const {
      rate,
      newMode,
      editMode,
      fieldConfiguration
    } = this.props;

    const {
      rate: rateFieldConfiguration
    } = fieldConfiguration;

    const {
      displayInactivePromoCodes
    } = this.state;

    const activePromoCodeTableRows = [];
    const inactivePromoCodeTableRows = [];
    rate.fields.promo_codes.value.forEach((promoCode, index) => {
      const promoCodeTableRow = { ident: index, data: promoCode };
      if ([ true, null ].includes(promoCode.fields.is_active.value)) {
        activePromoCodeTableRows.push(promoCodeTableRow);
      }
      else {
        inactivePromoCodeTableRows.push(promoCodeTableRow);
      }
    });

    const requiredFieldState = (newMode || editMode);

    return (
      <div>
        <FieldGroup>
          <Field label="Name"
            id="parkchirp--rate--name"
            required={requiredFieldState}
            layout="columns">
            <InputTextField inputId="parkchirp--rate--name"
              value={rate.fields.name.value}
              onChange={this._onInputChange('name')}
              editMode={newMode || editMode}
            />
          </Field>
          <Field label="Status"
            id="parkchirp--rate--active"
            required={requiredFieldState}
            layout="columns">
            <InputRadioGroupField inputId="parkchirp--rate--active"
              options={rateFieldConfiguration.active.options}
              value={rate.fields.active.value}
              onChange={this._onInputChange('active')}
              editMode={newMode || editMode}
            />
          </Field>
        </FieldGroup>
        <FieldGroup label="Categories">
          <Field label="Pass Type"
            id="parkchirp--rate--pass-type"
            required={requiredFieldState}
            layout="columns">
            <InputSelectField inputId="parkchirp--rate--pass-type"
              value={rate.fields.pass_type.value}
              options={[{ value: null, label: '' }, ...rateFieldConfiguration.pass_type.options]}
              onChange={this._onInputChange('pass_type')}
              editMode={newMode || editMode}
            />
          </Field>
          <Field label="Location"
            id="parkchirp--rate--location"
            layout="columns">
            <InputTextField inputId="parkchirp--rate--location"
              value={rate.fields.location.value}
              onChange={this._onInputChange('location')}
              editMode={newMode || editMode}
            />
          </Field>
          <Field label="Access Hours"
            id="parkchirp--rate--access-hours"
            required={requiredFieldState}
            layout="columns">
            <InputSelectField inputId="parkchirp--rate--access-hours"
              value={rate.fields.access_hours.value}
              options={[{ value: null, label: '' }, ...rateFieldConfiguration.access_hours.options]}
              onChange={this._onInputChange('access_hours')}
              editMode={newMode || editMode}
            />
          </Field>
        </FieldGroup>
        <FieldGroup label="Online">
          <Field label="Display Online"
            id="parkchirp--rate--display"
            required={requiredFieldState}
            layout="columns">
            <InputSelectField inputId="parkchirp--rate--display"
              value={rate.fields.display.value}
              options={[{ value: null, label: '' }, ...rateFieldConfiguration.display.options]}
              onChange={this._onInputChange('display')}
              editMode={newMode || editMode}
            />
          </Field>
          {(rate.fields.display.value !== 'ADMIN_SIGN_UP_ONLY') &&
            <Field label="Description"
              id="parkchirp--rate--description"
              layout="stacked">
              <InputTextField inputId="parkchirp--rate--description"
                value={rate.fields.description.value}
                onChange={this._onInputChange('description')}
                editMode={newMode || editMode}
                multiLine={true}
              />
            </Field>
          }
          {(rate.fields.display.value !== 'ADMIN_SIGN_UP_ONLY') &&
            <Field label="Make Model &amp; License Plate"
              id="parkchirp--rate--require-car-info"
              required={requiredFieldState}
              layout="columns">
              <InputSelectField inputId="parkchirp--rate--require-car-info"
                value={rate.fields.require_car_info.value}
                options={[{ value: null, label: '' }, ...rateFieldConfiguration.require_car_info.options]}
                onChange={this._onInputChange('require_car_info')}
                editMode={newMode || editMode}
              />
            </Field>
          }
        </FieldGroup>
        {(rate.fields.display.value === 'PROMO_CODE_REQUIRED') &&
          <FieldGroup label="Promo Codes">
            <PromoCodeTable inputId="parkchirp--rate--active-promo-codes"
              promoCodeRows={activePromoCodeTableRows}
              onValueChange={this._onPromoCodeChange}
              editMode={newMode || editMode}
            />
            <div>
              {(newMode || editMode) &&
                <button type="button"
                  onClick={this.handleAddPromoCodeClick}>
                  Add Promo Code
                </button>
              }
              {(inactivePromoCodeTableRows.length > 0) &&
                <button type="button"
                  onClick={this.handleToggleInactivePromoCodesClick}>
                  {(this.state.displayInactivePromoCodes) ? 'Hide' : 'Show'} Inactive Promo Codes
                </button>
              }
            </div>
            {(displayInactivePromoCodes) &&
              <PromoCodeTable inputId="parkchirp--rate--inactive-promo-codes"
                promoCodeRows={inactivePromoCodeTableRows}
                editMode={false}
              />
            }
          </FieldGroup>
        }
      </div>
    );
  }
}
export default RateDetailGeneralPanel;
